import { render, staticRenderFns } from "./OnboardingFormLayout.vue?vue&type=template&id=95ff485e&"
import script from "./OnboardingFormLayout.vue?vue&type=script&lang=js&"
export * from "./OnboardingFormLayout.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingFormLayout.vue?vue&type=style&index=0&id=95ff485e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports